module.exports = __webpack_public_path__ + "static/img/14.5f11de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/14.png
// module id = Jibf
// module chunks = 1